<template>
    <div class="frmdashboard_epkartya_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>


        <div class="frmdashboard_epkartya_itemcont" v-html="HtmlContent" />


    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmdashboard_epkartya',
  components: {
      GrcDB,
      GrcDialog,
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmDashboard_EPKARTYA_",

          InitDone:false,
          HtmlContent:"",


      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmDashboard_EPKARTYA", pCompName);
    },

    SetLang()
    {
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.HtmlContent = Q.RESULT[0].HtmlContent;

        this.InitDone = true;

      },

    async ShowError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


